export default class BackgroundImagePosition {
  scale = 1;
  private _posX = 0;
  public get posX() {
    return this._posX || 0;
  }
  public set posX(value) {
    this._posX = value || 0;
  }
  posY = 0;
  fade = 0;
  width: number | undefined;
  height: number | undefined;
  rotation = 0;

  constructor() {
    this.fade = state.settings.defaultBackgroundPictureElements.fade;
    this.scale = state.settings.defaultBackgroundPictureElements.scale;
  }

  copy(): BackgroundImagePosition {
    const c = new BackgroundImagePosition();
    c.scale = this.scale;
    c.posX = this.posX;
    c.posY = this.posY;
    c.fade = this.fade;
    c.width = this.width;
    c.height = this.height;
    c.rotation = this.rotation;
    return c;
  }

  fromJSON(data: any, obj: any): BackgroundImagePosition {
    const c = new BackgroundImagePosition();
    c.scale = data.scale;
    c.posX = data.posX;
    c.posY = data.posY;
    c.fade = data.fade;
    c.width = data.width;
    c.height = data.height;
    c.rotation = data.rotation;
    return c;
  }

  toJSON(): any {
    return {
      scale: this.scale,
      posX: this.posX,
      posY: this.posY,
      fade: this.fade,
      width: this.width,
      height: this.height,
      rotation: this.rotation,
    };
  }


  isEqual(other: BackgroundImagePosition): boolean {
    return (
      //
      this.scale == other.scale && //
      this.posX == other.posX && //
      this.posY == other.posY && //
      this.fade == other.fade &&
      this.width == other.width &&
      this.height == other.height &&
      this.rotation == other.rotation
    );
  }

  calcBackgroundImageTransform() {
    return `translate(${this.posX || 0}px, ${this.posY || 0}px) scale(${this.scale || 1}) `;
  }
}
